import { createResourceModule } from '../../../lib/resource/module.js';
import { guestDetail } from './schemas.js';

/**
 * The Guests module's API layer.
 *
 * The list, detail and update paths come from the shared factory. The PII
 * read is the module's own, because a reason and an explicit audit log sit
 * between a staff member and a guest's plaintext details.
 */
export const guests = createResourceModule({
  resource: 'guests',
  basePath: '/v1/guests',
  detail: guestDetail,
});

export const guestEndpoints = {
  ...guests.endpoints,
  pii: (guestId: string): string => `/v1/guests/${encodeURIComponent(guestId)}/pii`,
  countries: '/v1/countries/options?limit=50',
  states: (countryCode: string): string =>
    `/v1/states/options?countryCode=${encodeURIComponent(countryCode)}&limit=50`,
  cities: (countryCode: string, stateCode: string): string =>
    `/v1/cities/options?countryCode=${encodeURIComponent(countryCode)}&stateCode=${encodeURIComponent(stateCode)}&limit=50`,
} as const;
